import { markRaw } from "vue"
import { createPinia } from "pinia"
import { createPersistedState } from "pinia-plugin-persistedstate"

import router from "@/router.js"

import { storageOverride } from "@/store/storageOverride.js"

const pinia = createPinia()

pinia.use(
  createPersistedState({
    storage: storageOverride
  })
)
pinia.use(({ store }) => {
  store.$router = markRaw(router)
})

export default pinia
